<template>
	<div 
		class="nav-accordion overflow-hidden"
	>
		<button 
			class="flex flex-row justify-center items-center"
			@click="toggleAccordion"
		>
			{{ label }}
			<UiIcon v-if="isAccordionVisible" name="chevronUp"/>
			<UiIcon v-else name="chevronDown"/>
		</button>
		<transition 
      @before-enter="beforeExpand" @enter="expanded"
      @before-leave="beforeCollapse" @leave="collapsed"
		>
			<div 
				v-show="isAccordionVisible"
				class="accordion-list animate--collapsible overflow-y-scroll pt-3 pl-5"
				:style="{
					'max-height': listHeight
				}"
			>
				<div class="">
					<CategoryList 
						:cols="1" 
						:config="{
							'Featured': 1,
							'Therapeutic Areas':  1
						}"
					/>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import globalMixins from '@/mixins/global-mixins'

import UiIcon from '@/components/ui/Icon'
import CategoryList from '@/components/category/List'

/* eslint-disable no-console */
export default {
	name: 'CategoryAccordion',
	props: {
		label: {
			type: String,
			default: 'Accordion'
		},
		list: {
			type: Array,
			default: () => []
		},
		listHeight: {
			type: String,
			default: '240px'
		}
	},
	components: {
		UiIcon,
		CategoryList
	},
	mixins: [
		globalMixins
	],
	data() {
		return {
			isAccordionVisible: false
		}
	},
	watch: {
		$route() {
			this.unfocus()
		}
	},
	beforeMount() {
    window.addEventListener('resize', this.unfocus);
	},
  beforeUnmount() {
    window.removeEventListener('resize', this.unfocus);
  },
	methods: {
		toggleAccordion() {
			this.isAccordionVisible = !this.isAccordionVisible
		},
		unfocus() {
			if (this.isAccordionVisible) {
				this.isAccordionVisible = false
			}
		}
	}
}
</script>

<style scoped>
.accordion-list {
	z-index: 98;
	top: var(--navbar-height) !important;
}
</style>